import React from 'react';

import { ErrorPage } from 'src/components/templates/error-page';

const Error404: React.FC = () => <ErrorPage error="404">Trang truy cập không tồn tại</ErrorPage>;

export default Error404;
